export default {
  NEW: `#graphql
  mutation newOrderWholesaler($orderWholesaler: OrderInput!) {
    newOrderWholesaler(input: $orderWholesaler)
    {
      order
    }      
  }`,

  GET_ALL: `#graphql
  query getOrderWholesalers($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getOrderWholesalers(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    {
      docs {
        brand,
        order,
        status,
        dni,
        name,
        phones,
        email,
        address,
        listPrice,
        location,
        department,
        methodPay,
        methodPayCost,
        conveyor,
        conveyorCost,
        codeName,
        codeType,
        codePercent,
        codeValue,
        deliveryTime,
        mpCode,
        isWholesaler,
        isDropshipping,
        userPayConveyor,
        cod,
        tip,
        adviser,
        cart {
          product,
          sizes,
          quantityCart,
          images,
          priceUnit,
          priceThree,
          priceThreeCommunity,
          priceWholesaler,
          priceSale,
          priceSaleCommunity,
          folder,
          subfolder,
          article,
          person,
          colors,
          picked,
          tiers,
          design
        },
        deliveries {
          delivery,
          conveyor,
          tracking,
          createdBy,
          createdAt,
          deliveredBy,
          deliveredAt,
          inProgressAt,
          inProgressBy,
          declinedAt,
          declinedBy,
          deliveredAt,
          deliveredBy,
          status
        }
        createdAt,
        declinedAt,
        declinedBy,
        approvedAt,
        approvedBy,
        paidAt,
        paidBy,
        packedAt,
        packedBy,
        sentAt,
        sentBy,
        deliveredAt,
        deliveredBy,
        collectedAt,
        collectedBy,
        collectedValue,
        payU {
          orderId,
          state,
          error,
          methodPay,
          value,
          success,
          cash {
            EXPIRATION_DATE,
            REFERENCE,
            URL_PAYMENT_RECEIPT_PDF,
            URL_PAYMENT_RECEIPT_HTML,
          },
          pse {
            BANK_URL
          },
          createdAt 
        },
        payManual {
          state,
          methodPay,
          value,
          createdAt,
          createdBy
        },
        observations {
          observation,
          type,
          createdAt,
          createdBy
        },
        total,
        subtotal,
        priceDiscount,
        codeDiscount,
        totalDiscount,
        percentPriceDiscount,
        percentCodeDiscount,
        percentTotalDiscount,
        quantity
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateOrderWholesaler($order: String!, $orderWholesalerUpdate: OrderUpdateInput!) {
    updateOrderWholesaler(order:$order, orderUpdate: $orderWholesalerUpdate)
    {
      order
    }            
  }`,

  UPDATE_PRICES: `#graphql
  mutation updatePricesOrderWholesaler($order: String!, $price: String!) {
    updatePricesOrderWholesaler(order: $order, price: $price) 
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/orderWholesaler.js